import art from '../assets/art.png';
import codeStyled from '../assets/code-styled.png';
import creativity from '../assets/creativity.png';
import dynamicRealtime from '../assets/dynamic-realtime.png';
import tabular from '../assets/tabular.png';
import shortAndSweet from '../assets/short-and-sweet.png';
import elaborate from '../assets/elaborate.png';
import multimedia from '../assets/multimedia.png';
import allProfile from '../assets/all-profile.png';

const categoryImage = [
  { "title":"default", 'image': ''},
  { "title":"all-profile", 'image': allProfile},
  { "title":"code-styled", 'image': codeStyled},
  { "title":"creativity", 'image': creativity},
  { "title":"art", 'image': art},
  { "title":"dynamic-realtime", 'image': dynamicRealtime},
  { "title":"tabular", 'image': tabular},
  { "title":"short-and-sweet", 'image': shortAndSweet},
  { "title":"elaborate", 'image': elaborate},
  { "title":"multimedia", 'image': multimedia}
];

export default categoryImage;
